import React, { useState } from "react";
import { Copy, Check, ChevronDown, ChevronUp, Play } from "lucide-react";
import CodeBlock from "./CodeBlock";

const METHOD_CLASS = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

const JsonBlock = ({ data, label }) => {
  const [copied, setCopied] = useState(false);
  const json = JSON.stringify(data, null, 2);

  const handleCopy = () => {
    navigator.clipboard.writeText(json);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <div className="apidocs-block-head">
        <span>{label}</span>
        <button type="button" onClick={handleCopy} title="Copy">
          {copied ? <Check size={13} /> : <Copy size={13} />}
        </button>
      </div>
      <pre className="apidocs-pre">{json}</pre>
    </div>
  );
};

const FieldsTable = ({ fields, label }) => {
  if (!fields || fields.length === 0) return null;
  return (
    <div>
      <span className="apidocs-label">{label}</span>
      <div className="apidocs-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Field</th>
              <th>Type</th>
              <th>Required</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((f) => (
              <tr key={f.name}>
                <td><code>{f.name}</code></td>
                <td>{f.type}</td>
                <td>
                  <span className={`ping-chip ${f.required ? "r" : "n"}`}>
                    {f.required ? "required" : "optional"}
                  </span>
                </td>
                <td>{f.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const EndpointDoc = ({ endpoint, onTryIt }) => {
  const [showHeaders, setShowHeaders] = useState(false);

  if (!endpoint) return null;

  return (
    <div id={endpoint.id}>
      <div className="apidocs-ep-head">
        <div className="apidocs-ep-path">
          <span className={`apidocs-method ${METHOD_CLASS[endpoint.method] || ""}`}>
            {endpoint.method}
          </span>
          <code>{endpoint.path}</code>
          {onTryIt && (
            <button type="button" onClick={onTryIt} className="apidocs-try">
              <Play size={12} />
              Try this request
            </button>
          )}
        </div>
        <h1>{endpoint.title}</h1>
        <p className="apidocs-lead">{endpoint.description}</p>
      </div>

      {endpoint.headers && (
        <div className="apidocs-headers">
          <button type="button" onClick={() => setShowHeaders(!showHeaders)}>
            Headers
            {showHeaders ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
          </button>
          {showHeaders && (
            <div className="apidocs-headers-box">
              {Object.entries(endpoint.headers).map(([k, v]) => (
                <div key={k}>
                  <span>{k}:</span> {v}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="apidocs-stack">
        <FieldsTable fields={endpoint.requestFields} label="Request body" />
        <FieldsTable fields={endpoint.queryParams} label="Query parameters" />
        {endpoint.requestBody && <JsonBlock data={endpoint.requestBody} label="Example request" />}
        {endpoint.responseBody && <JsonBlock data={endpoint.responseBody} label="Example response" />}
        {endpoint.codeExamples && (
          <div>
            <span className="apidocs-label">Code examples</span>
            <CodeBlock codeExamples={endpoint.codeExamples} />
          </div>
        )}
      </div>
    </div>
  );
};

export default EndpointDoc;
